import React, { useEffect, useState } from 'react'
import { Card, Grid, Divider, Button, TextField, Checkbox, FormControlLabel } from '@material-ui/core/'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import ThaiDateFnsUtils from '../../../../utils/ThaiDateFnsUtils'
import AccountCircle from '@material-ui/icons/AccountCircle';
import Home from '@material-ui/icons/Home';
import AccountBox from '@material-ui/icons/AccountBox';
import Business from '@material-ui/icons/Business';
import Work from '@material-ui/icons/Work';
import Mail from '@material-ui/icons/Mail';
import Phone from '@material-ui/icons/Phone';
import PhoneInTalk from '@material-ui/icons/PhoneInTalk';
import CalendarToday from '@material-ui/icons/CalendarToday';
import EventBusy from '@material-ui/icons/EventBusy';
import Sms from '@material-ui/icons/Sms';
import Add from '@material-ui/icons/Add';

import { operators, admin } from '../../../../api/'

import { useHistory } from 'react-router-dom'
import { useStoreRehydrated, useStoreActions } from '../../../../store'

import SuccessModal from 'components/modal/SuccessModal'
import FailModal from 'components/modal/FailModal'

export default function OrganizationAdd() {
    const history = useHistory()
    const isRehydrated = useStoreRehydrated()

    // Store Actions for Search
    const onSearchOperator = useStoreActions(a => a.operatorModel.searchOperatorDBD)

    // State for Search
    const [searchTaxNo, setSearchTaxNo] = useState('')
    const [isSearching, setIsSearching] = useState(false)
    const [hasData, setHasData] = useState(false)

    // Form State
    const [organizationData, setOrganizationData] = useState({
        companyName: '',
        companyAddress: '',
        email: '',
        telephoneNumber: '',
        mobileNumber: '',
        smsTelephone: '',
        isUseReport1_1_2: false,
        operatorQOS: [],
        startDate: null,
        endDate: null,
        taxNo: '',
    })

    const [openFailModal, setOpenFailModal] = useState(false)
    const [failMessage, setFailMessage] = useState('')
    const [openSuccessModal, setOpenSuccessModal] = useState(false)
    const [allQOSTypes, setAllQOSTypes] = useState([])

    const onOpenSuccessModal = () => {
        setOpenSuccessModal(!openSuccessModal)
        if (!openSuccessModal) {
            history.push('/admin/organization')
        }
    }

    const onOpenFailModal = () => {
        setOpenFailModal(!openFailModal)
    }

    const handleSearch = async () => {
        // if (!searchTaxNo) return
        setIsSearching(true)

        // MOCK DATA FOR TESTING
        const mockData = {
            "juristicType": "บริษัทมหาชนจำกัด",
            "juristicID": "0107564000014",
            "oldJuristicID": null,
            "registerDate": "20210107",
            "juristicName_TH": "บริษัท โทรคมนาคมแห่งชาติ จำกัด (มหาชน)",
            "juristicName_EN": "NATIONAL TELECOM PUBLIC COMPANY LIMITED",
            "registerCapital": "16000000000.00",
            "paidRegisterCapital": "16000000000.00",
            "numberOfObjective": "62",
            "numberOfPageOfObjective": null,
            "juristicStatus": "ยังดำเนินกิจการอยู่",
            "standardID": "0107564000014",
            "addressInformations": [
                {
                    "sequence": 1,
                    "addressName": "สำนักงานใหญ่",
                    "fullAddress": "99  ถนนแจ้งวัฒนะ",
                    "building": "",
                    "roomNo": "",
                    "floor": "",
                    "villageName": "",
                    "addressNo": "99",
                    "moo": "",
                    "soi": null,
                    "road": "แจ้งวัฒนะ",
                    "tumbol": "ทุ่งสองห้อง",
                    "ampur": "เขตหลักสี่",
                    "province": "กรุงเทพมหานคร",
                    "phone": "",
                    "email": ""
                }
            ]
        }

        try {
            // Simulate API delay
            await new Promise(resolve => setTimeout(resolve, 500));

            // USE MOCK DATA INSTEAD OF API
            //const data = mockData;


            // REAL API LOGIC
            const res = await onSearchOperator({ taxno: searchTaxNo })
            let data = null;

            if (res?.data1000101001) {
                const list = res.data1000101001.ResultList || res.data1000101001.resultList
                if (Array.isArray(list) && list.length > 0) {
                    data = list[0]
                }
            }


            if (data && (data.juristicID || data.taxNo)) {
                const addressInfo = data.addressInformations && data.addressInformations.length > 0 ? data.addressInformations[0] : {};

                let companyAddress = addressInfo.fullAddress || '';
                const tumbol = addressInfo.tumbol || '';
                const ampur = addressInfo.ampur || '';
                const province = addressInfo.province || '';

                if (province) {
                    if (province === 'กรุงเทพมหานคร') {
                        companyAddress = `${companyAddress} แขวง ${tumbol} เขต ${ampur} ${province}`
                    } else {
                        companyAddress = `${companyAddress} ตำบล ${tumbol} อำเภอ ${ampur} จังหวัด ${province}`
                    }
                }

                setOrganizationData(prev => ({
                    ...prev,
                    taxNo: data.juristicID || data.taxNo || searchTaxNo,
                    companyName: data.juristicName_TH || '',
                    companyAddress: companyAddress,
                    email: addressInfo.email || '',
                    telephoneNumber: addressInfo.phone || '',
                    mobileNumber: addressInfo.phone || '',
                }))
                setHasData(true)
            } else {
                setFailMessage('ไม่พบข้อมูลผู้ประกอบการจากเลขทะเบียนนิติบุคคลนี้')
                setOpenFailModal(true)
                setHasData(false)
            }
        } catch (error) {
            console.error(error)
            setFailMessage('เกิดข้อผิดพลาดในการค้นหา')
            setOpenFailModal(true)
            setHasData(false)
        } finally {
            setIsSearching(false)
        }
    }

    const onSubmit = async () => {
        // Prepare payload
        // The API expects an Operator object structure
        /* 
            OperatorName: string
            TaxNo: string
            IsUseReport1_1_2: bool
            StartDate: date
            EndDate: date
            OperatorQOS: [{ QOSTypeID: int }]
            OperatorInfos: [{
                BranchNo: "00000",
                Mobile: string,
                Email: string,
                SMSTelephone: string,
                Addr: string
            }]
        */

        const payload = {
            OperatorName: organizationData.companyName,
            TaxNo: organizationData.taxNo || searchTaxNo, // Fallback if manually entered
            IsUseReport1_1_2: organizationData.isUseReport1_1_2,
            StartDate: organizationData.startDate,
            EndDate: organizationData.endDate,
            OperatorQOS: organizationData.operatorQOS.map(id => ({ QOSTypeID: id })),
            OperatorInfos: [
                {
                    BranchNo: "00000",
                    Mobile: organizationData.telephoneNumber, // UI calls it telephoneNumber/Mobile loosely, map to Mobile as per API
                    Email: organizationData.email,
                    SMSTelephone: organizationData.smsTelephone,
                    Addr: organizationData.companyAddress || "-"
                }
            ]
        }

        if (!payload.OperatorName || !payload.TaxNo) {
            setFailMessage('กรุณากรอกข้อมูลสำคัญ (ชื่อผู้ประกอบการ, เลขทะเบียนนิติบุคคล) ให้ครบถ้วน')
            setOpenFailModal(true)
            return
        }

        if (payload.OperatorQOS.length === 0) {
            setFailMessage('กรุณาเลือกประเภทรายงานอย่างน้อย 1 ประเภท')
            setOpenFailModal(true)
            return
        }

        const res = await operators.createOperator(payload)
        if (res && (res.status === 200 || res.status === 201)) {
            onOpenSuccessModal()
        } else {
            setFailMessage(res?.data?.message || res?.response?.data?.message || 'เกิดข้อผิดพลาดในการบันทึก')
            onOpenFailModal()
        }
    }

    useEffect(() => {
        const fetchQOSTypes = async () => {
            const res = await operators.getQOSTypes()
            if (res.status === 200) {
                setAllQOSTypes(res.data)
            }
        }
        fetchQOSTypes()
    }, [])

    const onValueChange = (value, type) => {
        setOrganizationData(prev => {
            if (type === 'operatorQOS') {
                const current = [...prev.operatorQOS]
                const index = current.indexOf(value)
                if (index === -1) current.push(value)
                else current.splice(index, 1)
                return { ...prev, operatorQOS: current }
            }
            return { ...prev, [type]: value }
        })
    }

    return (
        <>
            <Grid className="p-10 ">
                {/* Search Section */}
                <Card className={`border-t-4 border-card_top_border mb-6`}>
                    <Grid className="p-5">
                        <Grid className="flex flex-row items-center mb-4">
                            <AccountCircle style={{ fontSize: 22 }} className="mr-1" />
                            <Grid className="font-bold text-sm text-card_header_color">
                                เพิ่มผู้ประกอบการ
                            </Grid>
                        </Grid>
                        <Divider className="mb-4" />
                        <Grid className="flex flex-col md:flex-row items-center gap-4">
                            <Grid className="flex-grow w-full md:w-auto">
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="ค้นหาด้วยเลขจดทะเบียนนิติบุคคล"
                                    value={searchTaxNo}
                                    onChange={(e) => setSearchTaxNo(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    placeholder="ระบุเลขจดทะเบียนนิติบุคคล 13 หลัก"
                                />
                            </Grid>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSearch}
                                disabled={isSearching}
                                style={{ height: '56px' }}
                            >
                                {isSearching ? 'กำลังค้นหา...' : 'ค้นหาข้อมูล'}
                            </Button>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>

            {hasData && (
                <>
                    <Grid className="p-10">
                        <Card className={`border-t-4 border-card_top_border`}>
                            <Grid className="flex flex-col justify-center items-start px-5">
                                <Grid className="flex flex-row mt-4 items-center justify-between w-full">
                                    <Grid className="flex flex-row">
                                        <Add style={{ fontSize: 22 }} className="mr-1" />
                                        <Grid className="font-bold text-sm text-card_header_color">
                                            เพิ่มผู้ประกอบการใหม่
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid className="mt-3 mb-1 w-full">
                                    <Divider />
                                </Grid>

                                {/* Form Info */}
                                {/* Tax No */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
                                        <AccountBox style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">เลขทะเบียนนิติบุคคล</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex w-full pr-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            value={organizationData.taxNo}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>

                                {/* Company Name */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
                                        <Business style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">ชื่อหน่วยงาน</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex w-full pr-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            value={organizationData.companyName}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>

                                {/* Address */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
                                        <Home style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">ที่อยู่</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex w-full pr-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            value={organizationData.companyAddress}
                                            onChange={e => onValueChange(e.target.value, 'companyAddress')}
                                        />
                                    </Grid>
                                </Grid>

                                {/* QOS Types */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 my-2 w-full bg-white min-h-[3rem]`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 px-4 bg-card_top_border self-stretch`}>
                                        <Work style={{ fontSize: 20 }} className="mr-1 text-white" />
                                        <Grid className="text-white text-sm">ประเภทรายงาน</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex flex-wrap py-2">
                                        {allQOSTypes
                                            .sort((a, b) => b.id - a.id)
                                            .map((qos) => (
                                                <FormControlLabel
                                                    key={qos.id}
                                                    control={
                                                        <Checkbox
                                                            checked={organizationData.operatorQOS.includes(qos.id)}
                                                            onChange={e => onValueChange(qos.id, 'operatorQOS')}
                                                            name={qos.qosTypeName}
                                                            color="primary"
                                                        />
                                                    }
                                                    label={qos.qosTypeName}
                                                    className="mr-4"
                                                />
                                            ))}
                                    </Grid>
                                </Grid>

                                {/* IsUseReport1_1_2 */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
                                        <PhoneInTalk style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">ชุดข้อมูลแบบประจำที่ประเภทเสียง</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex items-center">
                                        <Checkbox
                                            checked={organizationData.isUseReport1_1_2}
                                            onChange={e => onValueChange(e.target.checked, 'isUseReport1_1_2')}
                                            color="primary"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid className="mt-3 mb-1 w-full">
                                    <Divider />
                                </Grid>

                                {/* Start Date */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
                                        <CalendarToday style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">วันที่เริ่มการให้บริการ</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex items-center w-full">
                                        <MuiPickersUtilsProvider utils={ThaiDateFnsUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                variant="inline"
                                                format="dd/MM/yyyy"
                                                margin="normal"
                                                id="date-picker-inline-start"
                                                value={organizationData.startDate}
                                                onChange={(date) => onValueChange(date, 'startDate')}
                                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                                InputProps={{ disableUnderline: true }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>

                                {/* End Date */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
                                        <EventBusy style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">วันที่หยุดการให้บริการ</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex items-center w-full">
                                        <MuiPickersUtilsProvider utils={ThaiDateFnsUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                variant="inline"
                                                format="dd/MM/yyyy"
                                                margin="normal"
                                                id="date-picker-inline-end"
                                                value={organizationData.endDate}
                                                onChange={(date) => onValueChange(date, 'endDate')}
                                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                                InputProps={{ disableUnderline: true }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Card>
                    </Grid>

                    {/* Contact Info Card */}
                    <Grid className="px-10 pb-10">
                        <Card className={`border-t-4 border-card_top_border`}>
                            <Grid className="flex flex-col justify-center items-start px-5">
                                <Grid className="flex flex-row mt-4 items-center justify-between w-full">
                                    <Grid className="flex flex-row">
                                        <Business style={{ fontSize: 22 }} className="mr-1" />
                                        <Grid className="font-bold text-sm text-card_header_color">
                                            ข้อมูลสำหรับการแจ้งเตือน
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid className="mt-3 mb-1 w-full">
                                    <Divider />
                                </Grid>

                                {/* Email */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
                                        <Mail style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">อีเมล</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex w-full pr-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            value={organizationData.email}
                                            onChange={e => onValueChange(e.target.value, 'email')}
                                        />
                                    </Grid>
                                </Grid>

                                {/* Mobile */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
                                        <Phone style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">เบอร์ติดต่อ</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex w-full pr-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            value={organizationData.telephoneNumber}
                                            onChange={e => onValueChange(e.target.value, 'telephoneNumber')}
                                        />
                                    </Grid>
                                </Grid>

                                {/* SMS */}
                                <Grid className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
                                    <Grid className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
                                        <Sms style={{ fontSize: 20 }} className="mr-1 h-full text-white" />
                                        <Grid className="text-white text-sm">เบอร์รับการแจ้งเตือน</Grid>
                                    </Grid>
                                    <Grid className="pl-4 text-sm flex w-full pr-4">
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="standard"
                                            InputProps={{ disableUnderline: true }}
                                            value={organizationData.smsTelephone}
                                            onChange={e => onValueChange(e.target.value, 'smsTelephone')}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid className="flex justify-between w-full my-5">
                                    <Button variant="outlined" onClick={() => history.goBack()}>
                                        ย้อนกลับ
                                    </Button>
                                    <Button variant="contained" color="primary" onClick={onSubmit}>
                                        บันทึกข้อมูล
                                    </Button>
                                </Grid>

                            </Grid>
                        </Card>
                    </Grid>
                </>
            )}

            <SuccessModal
                title={'เพิ่มผู้ประกอบการสำเร็จ'}
                open={openSuccessModal}
                handleButton={onOpenSuccessModal}
            />
            <FailModal
                title={'เพิ่มผู้ประกอบการไม่สำเร็จ'}
                description={failMessage}
                open={openFailModal}
                handleButton={onOpenFailModal}
            />
        </>
    )
}
